import React, {useEffect, useState} from "react";
import {Modal} from "../../../../ui/Modal/Modal";
import {ModalContentProps} from "../ModalContent";
import {
    ContentNotification,
    ContentTop,
    ContentXsTop,
    Gap8, GendersGap,
    NotificationList,
    Radio
} from "../../../../components/ui/Content";
import {InputElement} from "../../../../ui/Input/Input";
import {Body1, Caption2} from "../../../../components/Font";
import {useTheme} from "styled-components";
import moment from "moment";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {cleanAllErrors, cleanError, PatchPerson} from "../api/slice";
import {IPersonalInfo, ISex} from "../../../../interface/Passport/Account/frontend";
import {DatePicker} from "../../../../ui/FormDatePicker/DatePickerSelectors";
import {Info} from "../../../../icon/Icon";
import {useTranslation} from "react-i18next";
// import {clearRegistered} from "../../../Auth/slice";

export const ChangePersonalInfo = ({onGoBack, onGoInfoModal, isInfoModalOpen}: ModalContentProps) => {
    const dispatch = useAppDispatch()
    const Theme = useTheme()
    const {t} = useTranslation()
    const {gender, personalInfo, error, isFetching} = useAppSelector(state => state.account)

    const [info, setInfo] = useState<IPersonalInfo>({
        surname: '',
        name: '',
        patronymic: null,
        sex_id: null,
        birthdate: null,//.utc().format('DD.MM.YYYY')
        sex: null
    })

    useEffect(() => {
        setInfo({
            ...info,
            surname: personalInfo.surname,
            name: personalInfo.name,
            patronymic: personalInfo.patronymic,
            sex_id: personalInfo.sex_id,
            birthdate: personalInfo.birthdate
        })
    }, [personalInfo])

    const content = () => {
        return <>

            {/*{registered &&*/}
                <ContentNotification style={{background: '#F3F4F5', padding: '18px', marginBottom: '24px'}}>
                    <div>
                        <Info/>
                    </div>
                    <NotificationList>
                        <Body1>{t('passport.change_personal_notification')}</Body1>
                    </NotificationList>
                </ContentNotification>
            {/*}*/}
            <Caption2 color={Theme.color.secondary}>
                Фамилия
            </Caption2>
            <ContentXsTop>
                <InputElement
                    error={error['surname']}
                    value={info.surname}
                    onChange={value => {
                        if (error['surname']) {
                            dispatch(cleanError('surname'))
                        }
                        setInfo({...info, surname: value})
                    }}/>
            </ContentXsTop>
            <ContentTop>
                <Caption2 color={Theme.color.secondary}>
                    Имя
                </Caption2>
                <ContentXsTop>
                    <InputElement
                        error={error['name']}
                        value={info.name}
                        onChange={value => {
                            if (error['name']) {
                                dispatch(cleanError('name'))
                            }
                            setInfo({...info, name: value})
                        }}/>
                </ContentXsTop>
            </ContentTop>
            <ContentTop>
                <Caption2 color={Theme.color.secondary}>
                    Отчество (при наличии)
                </Caption2>
                <ContentXsTop>
                    <InputElement
                        error={error['patronymic']}
                        value={info.patronymic ?? ''}
                        onChange={value => {
                            if (error['patronymic']) {
                                dispatch(cleanError('patronymic'))
                            }
                            setInfo({...info, patronymic: value})
                        }}/>
                </ContentXsTop>
            </ContentTop>
            <ContentTop>
                <Caption2 color={Theme.color.secondary}>
                    Дата рождения
                </Caption2>
                <ContentXsTop>
                    <DatePicker initDate={moment(info.birthdate).isValid() ? moment(info.birthdate) : null}
                                    error={error['birthdate']}
                                    onChange={(date) => {
                                        if (error['birthdate']) {
                                            dispatch(cleanError('birthdate'))
                                        }
                                        setInfo({...info, birthdate: moment(date)})
                                    }}/>
                </ContentXsTop>
            </ContentTop>
            <ContentTop>
                <Caption2 color={Theme.color.secondary}>
                    Пол
                </Caption2>
                <ContentXsTop>
                    <GendersGap>
                        {gender.map((item: ISex) => {
                            return (
                                <Gap8 key={item.id}>
                                    <Radio
                                        type='radio'
                                        checked={info.sex_id === item.id}
                                        onChange={() => {
                                            setInfo({...info, sex_id: item.id})
                                        }}/>
                                    <Body1>
                                        {item.name}
                                    </Body1>
                                </Gap8>
                            )
                        })}
                    </GendersGap>
                </ContentXsTop>
            </ContentTop>
        </>
    }
    return <Modal
        title={'Персональная информация'}
        isFetching={isFetching}
        disable={!info.name || !info.surname}
        onSubmit={() => {
            // if(registered){
            //     dispatch(clearRegistered())
            //     close()
            // }
            dispatch(PatchPerson(info))
        }}
        content={content}
        onClose={() => {
            // if(registered){
            //     dispatch(clearRegistered())
            // }
            dispatch(cleanAllErrors())
            if (isInfoModalOpen) {
                onGoInfoModal()
            }
            onGoBack()
        }}
        // noArrow={registered}
        // noArrow={registered}
        submitText={
            // registered ?
                t('passport.save_and_continue')
                // : t('passport.save')
        }
    />
}
